module.exports = __webpack_public_path__ + "static/media/anetwork-header.2df02dbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/anetwork-header.jpg
// module id = 388
// module chunks = 0